'use client'

import { SectionHead, useReveal } from '@/components/page-kit'
import { MarginList, MarginRow } from './margin-list'
import { LMS } from './data'

/* The four features as full entries on the margin rule, each closing on its
   authored `stat` — "40% better retention", "Built in minutes", "Per-learner
   insight", "Never miss a deadline".

   Heading is the first sentence of `description`, verbatim. */

const [firstSentence] = LMS.description.split(/(?<=\.)\s+/)

export function LmsFeatures() {
  const list = useReveal<HTMLDivElement>(0.1)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead eyebrow="Key features" title={firstSentence} />

        <div ref={list.ref} className="mt-10 sm:mt-12">
          <MarginList shown={list.shown}>
            {LMS.features.map((f, i) => (
              <MarginRow
                key={f.title}
                index={i}
                shown={list.shown}
                className="py-6 sm:py-8"
              >
                <article>
                  <h3 className="font-heading text-lg font-normal leading-snug text-foreground sm:text-xl">
                    {f.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {f.description}
                  </p>
                  <p className="font-heading mt-4 text-base font-normal leading-tight text-emerald-600 sm:text-lg dark:text-primary-active">
                    {f.stat}
                  </p>
                </article>
              </MarginRow>
            ))}
          </MarginList>
        </div>
      </div>
    </section>
  )
}
